import React from 'react'

function Rapidez({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" {...r}>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M39.55 55.63c11.454 0 20.74-9.286 20.74-20.74 0-11.454-9.286-20.74-20.74-20.74-11.454 0-20.74 9.286-20.74 20.74 0 11.454 9.286 20.74 20.74 20.74z"
      ></path>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M39.55 20.17c8.13 0 14.72 6.59 14.72 14.72s-6.59 14.72-14.72 14.72c-3.32 0-6.38-1.1-8.84-2.95m4.77-38.6h8.14m-4.07.21v4.84"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M39.65 27.76v6.98l7.04 7.04M8.63 26.56h7.57M7.36 43.22h8.78M1.53 34.89h13.2"
      ></path>
      <path
        fill="#00033A"
        d="M27.54 44.93a1.23 1.23 0 100-2.46 1.23 1.23 0 000 2.46z"
      ></path>
    </svg>
  )
}

export default Rapidez